<template>
    <div>
        <div class="newdetail">
            <div class="aboutBaner">
                <img src="@/common/image/aboutbanner.jpg" alt="">
                <p>威法定制 大宅至简</p>
            </div>
            <div class="founder spaceCustomization">
                <div class="yishu"></div>
                <div class="beijing">{{object.title}}</div>
                <div class="newdetailtime" >{{object.publishDate}}</div>       
            </div>
            <div class="newcont">
                <div v-html="object.content" class="newcontnei" ref="object">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getEnterpriseNews } from "@/api/api";
import { getEnterpriseDynamic } from "@/api/api";


export default {
  name: '',
  data(){
      return{
          object:{}
      }
  },
  components: {
  },
    mounted() {
            let paths;
    if (sessionStorage.getItem("language") == 1) {
      paths = "";
    } else if (sessionStorage.getItem("language") == 2) {
      paths = "/En";
    } else {
      paths = "/It";
    }
        if (this._isMobile()) {
            this.$router.replace('/mnewDetails?id='+this.$route.query.id+'&isnew='+this.$route.query.isnew);
        } else {
            this.$router.replace(paths+'/newDetails?id='+this.$route.query.id+'&isnew='+this.$route.query.isnew);
        }
        let data = {
            id:this.$route.query.id
        }
        if(this.$route.query.isnew == 0){
            this.getnewsData(data)
        }else{
            this.getEnterprissData(data)
        }
  },
  methods:{
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        getnewsData(data){
            getEnterpriseNews(data)
            .then(res => {
                this.object = res.object
                // 处理content字段中的图片URL：替换路径并编码特殊字符
                if (this.object.content) {
                    this.object.content = this.processContentImages(this.object.content);
                }
                let str="video"
                let indext=res.object.content.indexOf(str)
                // console.log(this.$refs.object.contains("video"))
                if(indext!=-1){
                 res.object.content=  res.object.content.slice(0,indext-0+5)+" autoplay"+res.object.content.slice(indext-0+5)
                     this.object = res.object
                }
            })
            .catch(res => {
                console.log(res)
            });
        },
        getEnterprissData(data){
            getEnterpriseDynamic(data)
            .then(res => {
                console.log(res)
                this.object = res.object
                // 处理content字段中的图片URL：替换路径并编码特殊字符
                if (this.object.content) {
                    this.object.content = this.processContentImages(this.object.content);
                }
            })
            .catch(res => {
                console.log(res)
            });
        },
        /**
         * 处理content字段中的图片URL
         * 1. 替换路径：/vifacms -> /resource
         * 2. 编码URL中的特殊字符（特别是$符号）
         */
        processContentImages(content) {
            if (!content) {
                return content;
            }
            
            // 替换路径前缀
            let processed = content.replace(/\/vifacms\//g, '/resource/');
            
            // 使用正则表达式匹配img标签中的src属性
            const imgPattern = /(<img[^>]*src=["'])([^"']+)(["'][^>]*>)/gi;
            processed = processed.replace(imgPattern, (match, before, url, after) => {
                // 替换路径
                if (url.includes('/vifacms/')) {
                    url = url.replace(/\/vifacms\//g, '/resource/');
                }
                
                // 如果URL中包含$符号且未被编码，则进行编码
                if (url.includes('$') && !url.includes('%24')) {
                    // 分离URL的各个部分
                    if (url.startsWith('http://') || url.startsWith('https://')) {
                        // 完整URL：需要编码路径部分
                        const pathStart = url.indexOf('/', 8);
                        if (pathStart > 0) {
                            const domain = url.substring(0, pathStart);
                            const path = url.substring(pathStart);
                            // 编码路径中的$符号
                            const encodedPath = this.encodeUrlPath(path);
                            url = domain + encodedPath;
                        }
                    } else {
                        // 相对路径：直接编码
                        url = this.encodeUrlPath(url);
                    }
                }
                
                return before + url + after;
            });
            
            return processed;
        },
        /**
         * 编码URL路径中的特殊字符
         */
        encodeUrlPath(path) {
            if (!path) {
                return path;
            }
            
            try {
                // 分离路径和文件名
                const lastSlash = path.lastIndexOf('/');
                if (lastSlash >= 0) {
                    const dirPath = path.substring(0, lastSlash + 1);
                    const fileName = path.substring(lastSlash + 1);
                    // 编码文件名中的$符号
                    const encodedFileName = fileName.replace(/\$/g, '%24');
                    return dirPath + encodedFileName;
                } else {
                    // 只有文件名
                    return path.replace(/\$/g, '%24');
                }
            } catch (e) {
                // 出错时至少替换$为%24
                return path.replace(/\$/g, '%24');
            }
        },
    }
}
</script>

<style>
.newdetail .founder .yishu{
    margin-top: 50px;
    height: 35px;
}
.newdetail .founder .beijing{
    font-size: 30px;
    padding-top: 35px;
    line-height: 40px;
}
.newdetailtime{
    color:#b2aeac;
    padding-bottom: 35px;
}
.newcont{
    text-align: justify;
}
.newcontnei{
    width: 1200px;
    margin: 0 auto;
}
.newcontnei p {
    padding-bottom: 30px;
    line-height: 2;
}
.newcont img{
    width: 100%;
    margin-top: 20px;
    /* margin-bottom: 50px; */
}
.newcontnei p.navtit{
    font-size: 25px;
}
</style>
